import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { apiBase } from './api-config';
import { Order, CreateOrderDto, CreateEncryptedOrderDto, ReopenOrderDto, OrderStatus, OrderComplaint } from '../models/order.model';

@Injectable({ providedIn: 'root' })
export class OrderService {
  private http = inject(HttpClient);
  private url = `${apiBase}/orders`;

  getAll(filters: { status?: OrderStatus; partnerId?: number; areaId?: number; assignedLeadId?: number; from?: string; to?: string } = {}): Observable<Order[]> {
    const params: any = {};
    if (filters.status) params.status = filters.status;
    if (filters.partnerId) params.partnerId = filters.partnerId.toString();
    if (filters.areaId) params.areaId = filters.areaId.toString();
    if (filters.assignedLeadId) params.assignedLeadId = filters.assignedLeadId.toString();
    if (filters.from) params.from = filters.from;
    if (filters.to) params.to = filters.to;
    return this.http.get<Order[]>(this.url, { params });
  }

  getById(id: number): Observable<Order> {
    return this.http.get<Order>(`${this.url}/${id}`);
  }

  create(dto: CreateOrderDto): Observable<Order> {
    return this.http.post<Order>(this.url, dto);
  }

  createEncrypted(dto: CreateEncryptedOrderDto): Observable<Order> {
    return this.http.post<Order>(`${this.url}/pii`, dto);
  }

  update(id: number, dto: Partial<CreateOrderDto>): Observable<Order> {
    return this.http.put<Order>(`${this.url}/${id}`, dto);
  }

  reopen(id: number, dto: ReopenOrderDto): Observable<Order> {
    return this.http.post<Order>(`${this.url}/${id}/reopen`, dto);
  }

  addComplaint(orderId: number, dto: { complaintTypeId: number; deviceId?: number; description?: string }): Observable<OrderComplaint> {
    return this.http.post<OrderComplaint>(`${this.url}/${orderId}/complaints`, dto);
  }

  resolveComplaint(orderId: number, complaintId: number): Observable<OrderComplaint> {
    return this.http.patch<OrderComplaint>(`${this.url}/${orderId}/complaints/${complaintId}/resolve`, {});
  }

  markComplaintWontDo(orderId: number, complaintId: number, reason?: string): Observable<OrderComplaint> {
    return this.http.patch<OrderComplaint>(`${this.url}/${orderId}/complaints/${complaintId}/wont-do`, { reason });
  }

  close(id: number): Observable<Order> {
    return this.http.post<Order>(`${this.url}/${id}/close`, {});
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.url}/${id}`);
  }
}
